export default __webpack_public_path__ + "static/media/cerrar_sesion.fbf1088d.svg";